import {ClassComponent, Vnode} from 'mithril';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LicenseLabel from './LicenseLabel';
import Picture from '../models/Picture';

interface EditablePictureLicenseAttrs {
    picture: Picture
}

export default class EditablePictureLicense implements ClassComponent<EditablePictureLicenseAttrs> {
    loading: boolean = false

    view(vnode: Vnode<EditablePictureLicenseAttrs>) {
        const {picture} = vnode.attrs;

        return m('.PictureLicenseAttribute', [
            m(LicenseLabel, {
                value: picture.license(),
                onchange: (value: string) => {
                    this.loading = true;

                    picture.save({
                        license: value,
                    }).then(() => {
                        this.loading = false;
                        m.redraw();
                    }).catch(err => {
                        this.loading = false;
                        m.redraw();
                        throw err;
                    });
                },
                editable: picture.canLicense(),
            }),
            this.loading ? LoadingIndicator.component({
                className: 'LoadingIndicator--inline',
                size: 'tiny',
            }) : null,
        ]);
    }
}
